import { FunctionComponent } from "react";
import { InwardModel } from "../../../../inventory/models/inventory_voucher";

interface GRNItemCardProps {
  item: InwardModel;
  projectDetails?: any;
}

const GRNItemCard: FunctionComponent<GRNItemCardProps> = ({
  item,
  projectDetails,
}) => {
  const deviceCount = item?.uniqueIds?.length ?? 0;
  const hasDevices =
    item?.item?.type === "Product" &&
    (item?.item?.subcategory === "Finished Goods" ||
      item?.item?.subcategory === "IT and Electronic Hardware");

  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 hover:shadow-lg transition-all duration-200 bg-white text-xs">
      {/* Header */}
      <div className="flex items-start justify-between p-3 border-b gap-2">
        <div className="min-w-0">
          <span className="inline-flex rounded-md bg-emerald-50 px-2 py-1 text-xs font-medium text-emerald-700">
            {item?.item?.item_code ?? "--"}
          </span>
          <h3 className="mt-2 text-sm font-semibold text-gray-900 break-words">
            {item?.item?.name ?? "--"}
          </h3>
        </div>
        <div className="text-right shrink-0">
          <p className="text-xs text-gray-500">Received</p>
          <p className="text-sm font-semibold text-emerald-600">
            {item?.received_unit_no ?? 0}
          </p>
          <p className="text-xs text-gray-500 mt-1">Unit</p>
          <p className="text-xs font-medium text-gray-900">
            {item?.item?.unit?.symbol ?? "--"}
          </p>
        </div>
      </div>

      {/* Details */}
      <div className="grid grid-cols-2 gap-x-6 gap-y-3 p-3 text-xs">
        <div>
          <p className="text-gray-500">Total PO Qty</p>
          <p className="font-medium">{item?.total_ordered_qty ?? "--"}</p>
        </div>
        <div>
          <p className="text-gray-500">Previously Received</p>
          <p className="font-medium">{item?.total_received_qty ?? 0}</p>
        </div>
        <div>
          <p className="text-gray-500">Project</p>
          <p className="font-medium break-words">
            {projectDetails?.project?.name ?? "--"}
          </p>
        </div>
        <div>
          <p className="text-gray-500">Cost Center</p>
          <p className="font-medium break-words">
            {projectDetails?.project?.cost_center_category ?? "--"}
          </p>
        </div>
        <div>
          <p className="text-gray-500">Cost Center ID</p>
          <p className="font-medium">
            {projectDetails?.project?.cost_center_id ?? "--"}
          </p>
        </div>
        {hasDevices && (
          <div>
            <p className="text-gray-500">Device IDs</p>
            <p className="font-medium">
              {deviceCount > 0 ? `${deviceCount} added` : "--"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GRNItemCard;
